import { zs } from './zod';

/** Money in integer cents (EUR). */
export const centsField = zs.number().int().min(0).max(100_000_000);
